"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sliceKey = exports.reducer = exports.bannersProviderActions = exports.initialState = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const slices_1 = require("../../utils/@reduxjs/slices");
const api_1 = require("../../utils/api");
const REDUCER_KEY = 'bannersProvider';
exports.initialState = (0, slices_1.getPreloadedState)(REDUCER_KEY, {
    items: [],
    host: '',
    fetchItems: api_1.requestInitialStateNew,
});
const bannersProviderSlice = (0, toolkit_1.createSlice)({
    name: REDUCER_KEY,
    initialState: exports.initialState,
    reducers: {
        fetchBanners(state) {
            state.fetchItems.loading = true;
        },
        fetchBannersSuccess(state, { payload }) {
            state.host = payload.host;
            state.items = payload.items;
            state.fetchItems.loading = false;
        },
        fetchBannersError(state, { payload }) {
            state.fetchItems.loading = false;
            state.fetchItems.error = payload;
        },
    },
});
exports.bannersProviderActions = bannersProviderSlice.actions, exports.reducer = bannersProviderSlice.reducer, exports.sliceKey = bannersProviderSlice.name;
//# sourceMappingURL=slice.js.map